import store from '../store/store';
import { mutatorAction } from 'satcheljs/';

const showOPayPanel = mutatorAction(
    'SHOW_OPAY_PANEL',
    function showOPayPanel(modalFlexPaneContent: JSX.Element) {
        store.shouldShowModalFlexPane = true;
        store.modalFlexPaneContent = modalFlexPaneContent;
    }
);

export default showOPayPanel;
